
export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Barátságos árak',
      description: 'Megfizethető árakon, minőségi szolgáltatás'
    },
    {
      icon: 'ri-heart-line',
      title: 'Bizalom, emberi hangvétel',
      description: 'Közvetlen, őszinte kommunikáció minden vendéggel'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Valós segítség',
      description: 'Nem "hotel premium", hanem valós segítség a problémáidra'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'XVII. kerület',
      description: 'Könnyű megközelítéssel, a XVII. kerületben'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Letisztult környezet',
      description: 'Nyugodt, szeparált helyiség egy szépségszalon stúdióban'
    }
  ];

  return (
    <section className="py-20 bg-stone-100">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stone-800 mb-6">
              Miért válassz engem?
            </h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              Egyszerű, őszinte szolgáltatás, ahol Te vagy a középpontban
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-amber-700`}></i>
                </div>
                <h3 className="text-xl font-semibold text-stone-800 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-stone-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
